import { type ElementType, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/utils";

type Width = "narrow" | "default" | "wide";
interface Props extends HTMLAttributes<HTMLDivElement> {
  width?: Width;
  as?: ElementType;
  children?: ReactNode;
}
const widthClasses: Record<Width, string> = {
  narrow: "max-w-[800px]", default: "max-w-[1200px]", wide: "max-w-[1400px]",
};
export const LSContainer = ({ width = "default", as: Tag = "div", className, children, ...rest }: Props) => (
  <Tag className={cn("relative z-[2] mx-auto w-full px-6 md:px-12", widthClasses[width], className)} {...rest}>
    {children}
  </Tag>
);
export default LSContainer;
